import { conversationsService } from '../../services/conversationsService'
import * as actionTypes from './ActionTypes'

export const getConversationsSuccess = conversations => {
  return {
    type: actionTypes.GET_CONVERSATIONS_SUCCESS,
    payload: { conversations },
  }
}

export const getConversations =
  ({ page = 1 }) =>
  async dispatch => {
    const response = await conversationsService.getConversations({
      page,
    })
    if (response.isOk) {
      dispatch(getConversationsSuccess(response.data))
    }
  }

export const clearConversationsRedux = () => {
  return {
    type: actionTypes.CLEAR_CONVERSATIONS_REDUX,
  }
}
